<template>
  <KeepAlive>
    <component :is="tableType" :channel="channel" :currentBalances="currentBalances" :key="key"></component>
  </KeepAlive>
</template>

<script>
export default {
  name: 'TableBalanceCurrentAddOns',
  components: {
    TableBalanceCurrentEmail: () => import('./TableBalanceCurrentEmail.vue'),
    TableBalanceCurrentSMS: () => import('./TableBalanceCurrentSMS.vue'),
  },
  props: {
    currentBalances: {
      type: Array,
      default: () => {},
    },
    channel: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      key: null,
    }
  },

  created() {
    this.key = Math.floor(Math.random() * 100) + 1
  },

  beforeDestroy() {
    this.$root.$off('update-close-popup')
  },

  computed: {
    tableType() {
      return this.channel == 'email' ? 'TableBalanceCurrentEmail' : 'TableBalanceCurrentSMS'
    },
  },
}
</script>

<style lang="scss" scope>
.addReduce {
  &__inputBefore {
    line-height: 52px;
  }
  &__inputBefore,
  &__input {
    height: 52px;
    appearance: none;
    border: none;
    padding: 0 0 0.5rem;
    border-bottom: 1px solid var(--gray-500);

    &:active,
    &:focus {
      appearance: none;
      outline: none;
    }
  }

  .addValue {
    cursor: pointer;
  }
}

.tableBalance {
  &__btn {
    width: 30px;
    height: 30px;
    line-height: 15px;
    padding: 5px;
    transition: box-shadow 300ms;
    &--active,
    &:hover:enabled {
      background: white;
    }
  }
}
</style>
